export default __webpack_public_path__ + "static/media/Project Vaani - RFP V2 -Argus mark-up.docx (3).62ee182a.pdf";